import type {
  Client,
  CommercialOperation,
  CommercialOperationStatus,
  CommercialOperationType,
} from '@/modules/commercial/types';

export type CommercialOperationListFilters = {
  status?: CommercialOperationStatus | 'all';
  type?: CommercialOperationType | 'all';
  search?: string;
};

export function filterCommercialOperations(
  operations: CommercialOperation[],
  filters: CommercialOperationListFilters,
): CommercialOperation[] {
  let result = [...operations];

  if (filters.status && filters.status !== 'all') {
    result = result.filter((o) => o.status === filters.status);
  }
  if (filters.type && filters.type !== 'all') {
    result = result.filter((o) => o.type === filters.type);
  }

  const q = filters.search?.trim().toLowerCase();
  if (q) {
    result = result.filter((o) => o.title.toLowerCase().includes(q));
  }

  return result;
}

export type ClientListFilters = {
  active?: 'all' | 'active' | 'inactive';
  search?: string;
};

export function filterClients(
  clients: Client[],
  filters: ClientListFilters,
): Client[] {
  let result = [...clients];
  if (filters.active === 'active') {
    result = result.filter((c) => c.active);
  } else if (filters.active === 'inactive') {
    result = result.filter((c) => !c.active);
  }
  const q = filters.search?.trim().toLowerCase();
  if (q) {
    result = result.filter(
      (c) =>
        c.name.toLowerCase().includes(q) ||
        c.businessName.toLowerCase().includes(q) ||
        c.email.toLowerCase().includes(q) ||
        c.taxId.toLowerCase().includes(q),
    );
  }
  return result;
}
